/**
 * loading_slides.ts — the loading screen's painting sequence (2026-09-10),
 * PURE: the four concept paintings under /loading/intro-loading crossfade
 * IN ORDER (one → 2 → 3 → 4 → one …) while the boot loading screen is up.
 * The module only advances a class; the cadence and the order live here.
 */
export const LOADING_SLIDE_COUNT = 4;
/** One painting holds this long before the next fades in (ms). */
export const LOADING_SLIDE_HOLD_MS = 7000;
/** The CSS crossfade length (index.html: `.load-slide` transition). */
export const LOADING_SLIDE_FADE_MS = 1600;

export function loadingSlideSrc(index1: number): string {
  return `/loading/intro-loading/loading-${index1}.webp`;
}

/** The next 1-based index in order, wrapping. */
export function nextLoadingSlide(index1: number, count = LOADING_SLIDE_COUNT): number {
  return (index1 % count) + 1;
}

/** Which 1-based painting shows `t` ms after the sequence began. */
export function loadingSlideAt(tMs: number, count = LOADING_SLIDE_COUNT, holdMs = LOADING_SLIDE_HOLD_MS): number {
  if (tMs <= 0) return 1;
  return (Math.floor(tMs / holdMs) % count) + 1;
}
